<template>
	<v-app id="">
		<Overlay />
		<ModalRequestError />
		<v-content>
			<v-container fluid fill-height>
				<v-layout align-center justify-center>
					<v-flex xs12 sm8 md4>
						<v-layout row wrap align-center justify-center>
							<v-flex xs5 md5 align-center justify-center class="mb-12">
								<v-img src="/img/logo.png" align-center width="250px" justify-center></v-img>
							</v-flex>
						</v-layout>
						<v-card outlined>
							<v-toolbar flat>
								<v-toolbar-title> <span class="font-weight-bold with0" style="font-size: 16pt">Alterar
										senha</span></v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn color="primary" @click="$router.push({name: 'login'})" outlined>Entrar</v-btn>
							</v-toolbar>
							<v-form ref="form">
								<v-card-text>
									<v-text-field outlined label="E-mail" v-model="dataResetPassword.email" type="text"
										autocomplete="new-email" :rules="rules.required" dense></v-text-field>

									<v-text-field outlined label="Nova senha" v-model="dataResetPassword.password"
										type="password" autocomplete="new-password" :rules="rules.password" dense>
									</v-text-field>

									<v-text-field label="Confirme sua nova senha"
										v-model="dataResetPassword.password_confirmation" type="password"
										autocomplete="new-password-confirmation" :rules="rules.password_confirmation"
										dense outlined>
									</v-text-field>
								</v-card-text>
								<v-card-actions>
									<v-btn @click="store" color="success" outlined>Salvar</v-btn>
								</v-card-actions>
							</v-form>
						</v-card>
					</v-flex>
				</v-layout>
			</v-container>
		</v-content>
	</v-app>
</template>

<script>
	import ModalRequestError from '@/components/shared/ModalRequestError'
	import Overlay from '@/components/shared/Overlay'
	import Snackbar from '@/components/shared/Snackbar'
	export default {
		props: {
			source: String,
		},
		components: {
			ModalRequestError,
			Overlay,
			Snackbar,
		},
		data: () => ({
			drawer: null,
			dataResetPassword: {
				email: '',
				password: '',
				password_confirmation: '',
				token: ''
			},
			rules: {
				email: [
					v => !!v || 'Campo obrigatório.'
				],
				password: [
					v => !!v || 'Campo obrigatório.'
				],
				password_confirmation: [
					v => !!v || 'Campo obrigatório.'
				],
			}
		}),

		methods: {
			store() {
				if (this.$refs.form.validate()) {

					this.$store.commit('setOverlay', true)
					this.$http.post(`${this.$urlApi}/password/reset`, this.dataResetPassword)
						.then(res => {
							this.$store.commit('setOverlay', false)
							this.$store.commit('snackbarSuccess', 'Senha altarada com sucesso.')
							this.$router.push({ name: 'login' })
						})
						.catch(e => {
							this.$store.commit('setOverlay', false)
							let stringErrors = [];

							Object.keys(e.response.data.errors).map(value => {
								return stringErrors.push(`${e.response.data.errors[value]}`);
							});

							this.$store.dispatch("showModalRequestError", stringErrors)
						})
				}

			}
		},
		created() {
			let user = this.$store.getters.getUser;
			if (user) {
				this.$router.push({ name: "home" });
			}


			this.$http.get(`${this.$urlApi}/password/find/${this.$route.params.token}`)
				.then(res => {
					this.dataResetPassword.email = res.data.email;
					this.dataResetPassword.token = res.data.token;
				})
		}
	}
</script>

<style scoped>
	#inspire {
		background: linear-gradient(to right, #232526, #414345);
	}
</style>